import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 1, viewBox: "0 0 20 1", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 1, fill: "#333333" }));
export default SvgMinus;
